;(function() {
  'use strict'

  controller.$inject = ["$transitions", "$scope", "$timeout"];
  angular
    .module('core.elementSelector')
    .controller('ElementSelector', controller)

  /* @ngInject */
  function controller($transitions, $scope, $timeout) {
    var DEFAULT_LIMIT = 10
    var whitespaceRegex = /\s+/g

    $scope.title = getTitle()
    $scope.search = _.debounce(search, 400)
    $scope.limit = DEFAULT_LIMIT
    $scope.increaseLimit = increaseLimit

    $transitions.onStart(null, closeDialog) // close dialog on route change

    search(null)

    function search(query) {
      // reset limit
      $scope.limit = DEFAULT_LIMIT

      // reset relevance
      _.each($scope.elements, function(element) {
        element.relevance = 0
      })

      // no query display all
      if (!query) {
        return setResults($scope.elements)
      }

      var queryWords = query.split(whitespaceRegex)
      var words = []
      var results = []

      // create a case-insensitive regex for each word
      _.each(queryWords, function(word) {
        words.push(new RegExp(word, 'i'))
      })

      // loop through elements
      _.each($scope.elements, function(element) {
        var keywords = [element.extras.title, element.extras.subtext].join(' ')

        _.each(words, function(word) {
          // add relevance for each word that matches
          if (keywords.match(word)) {
            element.relevance++
          }
        })

        // if relevant - add to results
        if (element.relevance > 0) {
          results.push(element)
        }
      })

      setResults(results)
    }

    function setResults(results) {
      $scope.$applyAsync(function() {
        $scope.results = results
      })
    }

    function closeDialog() {
      $timeout(function() {
        $scope.dialog.close()
      }, 100)
    }

    function increaseLimit() {
      $scope.limit += DEFAULT_LIMIT
    }

    function getTitle() {
      var types = _.uniq(_.map($scope.elements, 'type'))

      if (types.length > 1) {
        return "What's this about?"
      }

      if (types[0] === 'place') {
        return 'Which place is this about?'
      }

      if (types[0] === 'product') {
        return 'Which product is this about?'
      }

      return "What's this about?"
    }
  }
})()
